const normalizeEntityName = (name) => `${name ?? ''}`.trim().toLocaleLowerCase();

const getEntityId = (entity) => entity?.serverId ?? entity?.id ?? null;

export const hasDuplicateEntityName = (entities, name, excludedEntityId = null) => {
  const normalizedName = normalizeEntityName(name);
  if (!normalizedName) return false;

  return (Array.isArray(entities) ? entities : []).some((entity) => {
    const entityId = getEntityId(entity);
    const isExcluded =
      excludedEntityId != null && entityId != null && `${entityId}` === `${excludedEntityId}`;

    return !isExcluded && normalizeEntityName(entity?.name) === normalizedName;
  });
};

export const getDuplicateNameMessage = (entityLabel) =>
  `${entityLabel} name is already in use. Choose a unique name.`;
